import { render, staticRenderFns } from "./DescriptionEditor.vue?vue&type=template&id=55932a06"
import script from "./DescriptionEditor.vue?vue&type=script&lang=js"
export * from "./DescriptionEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports